module.exports = __webpack_public_path__ + "img/2_silver.4cc0962f.svg";